<div
    #tooltip
    class="templated-tooltip"
    >
    <ng-container [ngTemplateOutlet]="template" [ngTemplateOutletContext]="{ $implicit: data, instance: this }"></ng-container>
</div>
